export default __webpack_public_path__ + "static/media/icon-exit.d7aa3982.svg";